import { render, staticRenderFns } from "./jieTiTongFa.vue?vue&type=template&id=63e83748&scoped=true&"
import script from "./jieTiTongFa.vue?vue&type=script&lang=js&"
export * from "./jieTiTongFa.vue?vue&type=script&lang=js&"
import style0 from "./jieTiTongFa.vue?vue&type=style&index=0&id=63e83748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e83748",
  null
  
)

export default component.exports